import { apiFetch } from '@/api/client';
import type { PublishJob, PublishJobList } from '@/types';

interface ListOptions {
  // 'active' (default) = queued + publishing; 'all' also returns recent
  // terminal jobs.
  status?: 'active' | 'all';
}

interface BulkResult {
  enqueued: number;
  results: Array<{ article_id: string; job?: PublishJob; error?: string }>;
}

export const publishJobs = {
  // list scopes to one site's queue.
  list: (siteId: string, opts: ListOptions = {}) => {
    const params = new URLSearchParams({ site_id: siteId });
    if (opts.status === 'all') params.set('status', 'all');
    return apiFetch<PublishJobList>(`/publish-jobs/?${params.toString()}`);
  },
  // listGlobal returns every site's queue (the cross-site queue view + the
  // global in-flight badge count).
  listGlobal: (opts: ListOptions = {}) => {
    const params = new URLSearchParams({ include_global: 'true' });
    if (opts.status === 'all') params.set('status', 'all');
    return apiFetch<PublishJobList>(`/publish-jobs/?${params.toString()}`);
  },
  // enqueueBulk publishes N articles ("Publish N"); same-site jobs coalesce into
  // one deploy at the worker.
  enqueueBulk: (articleIds: string[], waive?: string[]) =>
    apiFetch<BulkResult>(`/publish-jobs/`, {
      method: 'POST',
      body: JSON.stringify({ article_ids: articleIds, waive }),
    }),
  // cancel a still-queued job (a publishing job is mid-deploy and cannot be
  // cancelled — the backend returns 409).
  cancel: (id: string) =>
    apiFetch<PublishJob>(`/publish-jobs/${encodeURIComponent(id)}/cancel`, {
      method: 'POST',
    }),
};
